export function newDtScope(): Omit<Knowledge.Condition['dtScope'], 'referenceIds'> {
  return {
    filterCode: 'DT_SPECIFIED',
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    referenceIds: [],
    specifiedDtRange: [],
    repeatType: 'NO_REPEAT',
    weekRepeat: [],
    dayRepeat: [
      {
        timeRanges: [],
      },
    ],
    yearRepeat: [
      {
        dtRanges: [],
      },
    ],
    activeDuration: {
      startAt: '',
      endAt: '',
    },
  };
}

export function newPresetTime(): Knowledge.PresetTime {
  return {
    name: '',
    dtScope: newDtScope(),
  };
}
